<template>
  <div class="res-video-wra">
    <video-player class="video-js vjs-big-play-centered" ref="video"
                  :options="playerOptions"
                  :playsinline="true"
                  @playing="onPlaying"
                  @ended="onEnd"></video-player>
  </div>
</template>
<script type="text/ecmascript-6">
  import 'video.js/dist/video-js.css'
  import { videoPlayer } from 'vue-video-player'
  import mixin from './attachMixin'
  import EventHandler from '../../js/EventHandler'

  export default {
    mixins: [mixin],
    data () {
      return {
        playerOptions: {
          width: '500px',
          height: '500px',
          autoplay: false,
          preload: 'true',
          aspectRato: '16:9',
          durationDisplay: true,
          fluid: true,
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: 'video/mp4',
            src: this.uFilePath
          }],
          poster: `${this.uFilePath}?vframe/jpg/offset/1`,
          controlBar: {
            timeDivider: true,//当前时间和持续时间的分隔符
            durationDisplay: true,//显示持续时间
            remainingTimeDisplay: false,//是否显示剩余时间功能
            fullscreenToggle: true  //全屏按钮
          }
        }
      }
    },
    mounted () {
      this.initVideoData()
    },
    watch: {
      uFilePath: {
        immediate: true,
        handler (value) {
          this.initVideoData()
        }
      }
    },
    methods: {
      onPlaying: function () {
        this.isPlaying = true
      },
      onEnd: function () {
        this.isPlaying = false
      },
      initVideoData () {
        const self = this
        self.playerOptions.sources[0].src = self.uFilePath
        self.playerOptions.poster = `${self.uFilePath}?vframe/jpg/offset/1`
      },
      // 播放
      togglePlay: function () {
        if(this.isPlaying){
          this.$refs.video.player.pause()
          this.isPlaying = false
        }else{
          this.$refs.video.player.play()
        }
      },
      // 快进
      fastForward: function () {
        this.$refs.video.player.currentTime(this.$refs.video.player.currentTime() + 15)
      },
      // 快退
      fastBackward: function () {
        if(this.$refs.video.player.currentTime() <= 15){
          this.$refs.video.player.currentTime(0)
        }else{
          this.$refs.video.player.currentTime(this.$refs.video.player.currentTime() - 15)
        }
      },
      handleMedia: function (type) {
        console.log(type+'--video')
        if(type == 1){
          this.togglePlay()
        }else if(type == 2){
          this.fastForward()
        }else if(type == 3){
          this.fastBackward()
        }
      }
    },
    components: {
      videoPlayer
    }
  }
</script>
<style lang="scss">
  .res-video-wra{
    .video-js{
      width: 100%;
      height: 100%;
    }
    .video-js .vjs-fluid,
    .video-js.vjs-fluid{
      padding-top: calc(100vh - 96px);
    }
    .vjs-control-bar  .vjs-time-control, 
    .vjs-control-bar .vjs-time-divider,
    .vjs-control-bar .vjs-duration{
      display: block;
    }
    .vjs-time-divider{
      padding-left: 0;
      padding-right: 0;
      min-width: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/common/components/uAttach/uVideoAttach.vue